<template>
  <div>
    <KarteUserConcern :karte="karte" />
  </div>
</template>

<script setup lang="ts">
import KarteUserConcern from '@/components/organisms/KarteUserConcern/KarteUserConcern.vue'

import { type UserConcernAndDiagnosisKarteFragment } from './UserConcernAndDiagnosis.generated'

defineProps<{
  karte: UserConcernAndDiagnosisKarteFragment
}>()
</script>
